import React from "react";

//import components
import DonutChart from "./DonutPercentage.jsx";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";


const InvoiceReportComponent = () => {
  const styles = {
    cardComponent: {
      marginTop: vh(5),
      width: "85%",
      height: "46vh",
      borderRadius: vw(10),
      /* border: 2px solid #192A3A; */
      backgroundColor: "hsl(0, 0%, 100%)",
      boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.1)",
      transition: "transform 0.3s",
      /* border: 0.5px solid #192A3A; */
      display: "flex",
      /* justify-content: space-between; */
      flexDirection: "column",
      /* flex-wrap: wrap; */
      fontSize: vh(14),
      padding: vh(20),
    },
    title: {
      fontSize: vh(24),
      fontWeight: "bold",
      fontFamily: "Karla, sans-serif",
      color: "#192A3A",
    },
    donutChart: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "50%",
      marginTop: vh(20),
    },
    bottomSection: {
      display: "flex",
      marginTop:vh(20),
      justifyContent: "center",
      gap: "20%",
     
    },
    bottomHalf: {
      display: "flex",
      flexDirection: "column",
      gap: vw(10),
    },
    verticalLine: {
      width: vw(2),
      backgroundColor: "#9d9d9d",
      height: "100%",
    },
    individualDetails: {
      display: "flex",
      alignItems: "start",
      gap: vw(10),
    },
    dotIcon: {
      width: vh(10),
      height: vh(10),
      borderRadius: "50%",
      marginTop: vh(5),
    },
    details: {
      display: "flex",
      flexDirection: "column",
      marginTop: "0%",
    },
    detailsTitle: {
      fontSize: vh(16),
      color: "#192A3A",
      
    },
    detailsValue: {
      fontSize: vh(14),
      color: "#9d9d9d",
    },
  };

  return (
    <div style={styles.cardComponent}>
      <div style={styles.title}>Report</div>
      <div style={styles.donutChart}>
      <DonutChart values={[25, 25, 25, 25]} colors={["#192A3A", "#64A371", "#377771", "#B99964"]} />
      </div>
      <div style={styles.bottomSection}>
        <div style={styles.bottomHalf}>
          <div style={styles.individualDetails}>
            <div style={{...styles.dotIcon, backgroundColor: "#192A3A" }}></div>
            <div style={styles.details}>
              <div style={styles.detailsTitle}>Water</div>
              <div style={styles.detailsValue}>$200</div>
            </div>
          </div>
          <div style={styles.individualDetails}>
          <div style={{...styles.dotIcon, backgroundColor: "#64A371" }}></div>
          <div style={styles.details}>
              <div style={styles.detailsTitle}>Rent</div>
              <div style={styles.detailsValue}>$200</div>
            </div>
          </div>
          
        </div>
        <div style={styles.verticalLine}></div>
        <div style={styles.bottomHalf}>
        <div style={styles.individualDetails}>
        <div style={{...styles.dotIcon, backgroundColor: "#377771" }}></div>
            <div style={styles.details}>
              <div style={styles.detailsTitle}>Garbage</div>
              <div style={styles.detailsValue}>$200</div>
            </div>
          </div>
          <div style={styles.individualDetails}>
          <div style={{...styles.dotIcon, backgroundColor: "#B99964" }}></div>
          <div style={styles.details}>
              <div style={styles.detailsTitle}>Service</div>
              <div style={styles.detailsValue}>$200</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceReportComponent;
